import { createRoot } from 'react-dom/client';

document.addEventListener('DOMContentLoaded', () => {
	const upgradePageEl = document.getElementById('bplUpgradePage');

	createRoot(upgradePageEl).render(<UpgradePageContent />);
});

const UpgradePageContent = () => {
	return <div className='fsUpgradePrice'>
		<style dangerouslySetInnerHTML={{
			__html: `
			#bplUpgradePage {
				.fsUpgradePrice {
					min-width: 100%;
					height: 2050px;
					max-height: 2050px;
					overflow: hidden;
				}
			}
			`.replace(/\s+/g, ' ')
		}} />

		<iframe src="https://wp.freemius.com/pricing/?plugin_id=14262&amp;plugin_public_key=pk_87f141adce326dfb96ba4e12d8a36" width="100%" height="800px" scrolling="no" frameBorder="0" style={{ background: 'transparent', width: '1px', minWidth: '100%', height: '2050px' }}></iframe>
	</div>
}